import channels from './channels'
import operators from './operators'

export default { channels, operators }
